import React from 'react';
import Utilities from '@util/Utilities';


const GeneralStatIndicatorPortlet: React.FunctionComponent<{
	title: string,
	stat: string,
	icon: React.ReactNode,
	trend?: number,
	trendSuffix?: string,
}>
	= ({ title, stat, icon, trend, trendSuffix = '' }) => {

	const hasTrend = trend !== undefined && trend !== 0;

	return <div className="overflow-hidden rounded-lg border border-gray-200 bg-white px-4 py-3 shadow-sm sm:px-5 sm:py-4">
		<dt className="inline-flex justify-between items-center w-full"><span
			className="truncate text-sm font-semibold text-gray-500">{title}</span>
			{icon}
		</dt>
		<dd className="mt-1 flex items-baseline gap-2">
			<span className="text-2xl font-bold tracking-tight text-gray-900">{stat}</span>
			{hasTrend && <span
				className={Utilities.classNames('text-sm font-medium', trend > 0 ? 'text-green-600' : 'text-red-600')}>
				{trend > 0 ? '+' : ''}{Utilities.formatDouble(trend, 0)}{trendSuffix}
			</span>}
		</dd>
	</div>;
};

export default GeneralStatIndicatorPortlet;
